import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 48 — Tour de la pantalla de Pedidos Activos.
 * Página con la mayor densidad de acciones del sistema. Explica tabs,
 * estados, botones dinámicos y operaciones avanzadas (dividir/juntar).
 */
export const tourPedidosActivos: TourDefinition = {
  id: 'pedidos_activos',
  title: 'Cómo gestionar los pedidos',
  steps: [
    {
      element: '[data-tour="pedidos-header"]',
      popover: {
        title: '1. Panel de pedidos',
        description:
          'Aquí ves y gestionas todos los pedidos en curso. El filtro "Activos" muestra solo los que están en proceso; "Todos" incluye los ya cobrados o cancelados (útil para consultar el historial del día).',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="pedidos-tabs-tipo"]',
      popover: {
        title: '2. Comer aquí vs A domicilio',
        description:
          'Cambia entre las dos vistas con estos tabs. Cada pestaña muestra el número de pedidos activos en ese momento. Los pedidos de comer aquí muestran número de mesa; los de domicilio muestran el nombre del cliente.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="pedidos-tabla"]',
      popover: {
        title: '3. La tabla de pedidos',
        description:
          'Cada fila es un pedido. El color del estado indica en qué fase está: amarillo = abierto (sin enviar a cocina), naranja = en cocina, verde = listo para entregar o cobrar. Los badges "Cuenta pedida" y "Cuenta dividida" aparecen cuando aplican.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="pedidos-tabla"]',
      popover: {
        title: '4. Botones de acción (dinámicos)',
        description:
          'Cada fila tiene botones que cambian según el tipo y estado del pedido. Los más importantes: 👁 Ver items (detalle del pedido), ➕ Agregar productos (solo comer aquí), 💰 Cobrar (cuando ya está listo), ✂️ Dividir cuenta (para que una mesa pague por separado).',
        side: 'top',
      },
    },
    {
      element: '[data-tour="pedidos-tabla"]',
      popover: {
        title: '5. Dividir y juntar cuentas',
        description:
          '"Dividir cuenta" parte los productos entre dos o más cuentas para que cada cliente pague lo suyo. Si luego la mesa decide pagar todo junto, usa "Volver a juntar" (aparece en las sub-cuentas divididas). También puedes "Mover mesa" si los clientes cambiaron de lugar o "Juntar mesas" para cobrar dos mesas juntas.',
        side: 'top',
      },
    },
  ],
};
